/* cfam-the — doi mau TAI CHO tren the san pham trang chu (strap-tabs). Chu shop 05/10/2026.
   Bam o mau (button[data-cfam-o]) -> KHONG chuyen trang: the doi sang san pham cua mau do
   (anh chinh + anh hover, ten, gia, link anh + link ten). Du lieu: /products/<handle>.js, nho theo handle,
   tai truoc khi re chuot / cham / focus vao o. Loi tai / 404 -> giu the cu (het hang van doi: shop lam theo don).
   Bang the cua strap-tabs nhan ban the (cloneNode) -> moi ban sao la mot <cfam-the> rieng, tu gan su kien. */
(function () {
  if (customElements.get('cfam-the')) return;

  var cache = new Map();
  var RONG = [600, 800];
  var MO = '.35';
  var TG = 'opacity .15s ease';

  function layJson(handle) {
    if (!cache.has(handle)) {
      var hua = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
      hua.catch(function () { cache.delete(handle); });
      cache.set(handle, hua);
    }
    return cache.get(handle);
  }

  function anhUrl(src, w) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(src) { return RONG.map(function (w) { return anhUrl(src, w) + ' ' + w + 'w'; }).join(', '); }
  function anhSo(p, i) {
    var a = p.images && p.images[i];
    if (!a) return '';
    return typeof a === 'string' ? a : a.src || '';
  }
  function taiAnh(src) {
    return new Promise(function (ok) {
      if (!src) return ok();
      var im = new Image();
      im.onload = im.onerror = function () { ok(); };
      im.src = anhUrl(src, RONG[RONG.length - 1]);
    });
  }

  /* gia: giu dung dinh dang dang hien tren the (ky hieu tien, vi tri) — chi thay con so */
  function giaChu(the, p) {
    var el = the.querySelector('.scard__price');
    if (!el) return;
    if (!el.dataset.cfamMau) el.dataset.cfamMau = el.textContent.trim().replace(/^From\s+/i, '');
    var mau = el.dataset.cfamMau;
    var xu = p.price_varies ? p.price_min : p.price;
    var so = (xu / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var chu = /[\d][\d.,]*/.test(mau) ? mau.replace(/[\d][\d.,]*/, so) : so;
    el.textContent = (p.price_varies ? 'From ' : '') + chu;
  }

  function apVao(the, p) {
    var url = p.url || ('/products/' + p.handle);
    var a0 = anhSo(p, 0) || p.featured_image;
    var a1 = anhSo(p, 1);
    var media = the.querySelector('.scard__media');
    var chinh = media && media.querySelector('img:not(.scard__media-hover)');
    var hov = media && media.querySelector('img.scard__media-hover');
    if (chinh && a0) {
      chinh.srcset = srcset(a0);
      chinh.src = anhUrl(a0, RONG[RONG.length - 1]);
      chinh.alt = p.title;
    }
    if (media && chinh) {
      if (a1) {
        if (!hov) {
          hov = chinh.cloneNode(false);
          hov.className = 'scard__media-hover';
          hov.removeAttribute('fetchpriority');
          media.appendChild(hov);
        }
        hov.srcset = srcset(a1);
        hov.src = anhUrl(a1, RONG[RONG.length - 1]);
        hov.alt = p.title;
      } else if (hov) {
        hov.remove();
      }
    }
    the.querySelectorAll('a.scard__link').forEach(function (a) { a.href = url; });
    var ml = the.querySelector('a.scard__media-link');
    if (ml) ml.setAttribute('aria-label', p.title);
    var ten = the.querySelector('.scard__name');
    if (ten) ten.textContent = p.title;
    giaChu(the, p);
  }

  function mo(the, bat) {
    the.querySelectorAll('.scard__media, .scard__info a.scard__link').forEach(function (x) {
      x.style.transition = TG;
      x.style.opacity = bat ? MO : '';
    });
  }

  class CfamThe extends HTMLElement {
    connectedCallback() {
      if (this._gan) return;
      this._gan = true;
      var self = this;
      this.addEventListener('click', function (e) {
        var o = e.target.closest && e.target.closest('button[data-cfam-o]');
        if (!o || !self.contains(o)) return;
        e.preventDefault();
        e.stopPropagation();
        self.chon(o);
      });
      var truoc = function (e) {
        var o = e.target.closest && e.target.closest('button[data-cfam-o]');
        if (!o || !o.dataset.handle) return;
        layJson(o.dataset.handle).then(function (p) { return taiAnh(anhSo(p, 0) || p.featured_image); }).catch(function () {});
      };
      this.addEventListener('pointerover', truoc);
      this.addEventListener('focusin', truoc);
      this.addEventListener('touchstart', truoc, { passive: true });
    }

    chon(o) {
      if (o.classList.contains('is-nay') || this._dang) return;
      var the = this.closest('.scard') || this.closest('li');
      if (!the) return;
      var cu = this.querySelector('button[data-cfam-o].is-nay');
      var self = this;
      this._dang = true;
      this.querySelectorAll('button[data-cfam-o]').forEach(function (b) {
        var nay = b === o;
        b.classList.toggle('is-nay', nay);
        b.setAttribute('aria-pressed', nay ? 'true' : 'false');
      });
      mo(the, true);
      layJson(o.dataset.handle)
        .then(function (p) {
          /* shop lam theo don (ton kho 0 van ban) -> KHONG chan available:false; chi giu the cu khi loi tai / 404 */
          return taiAnh(anhSo(p, 0) || p.featured_image).then(function () { return p; });
        })
        .then(function (p) {
          apVao(the, p);
          requestAnimationFrame(function () { mo(the, false); });
        })
        .catch(function () {
          /* giu the cu: tra lai o dang chon */
          self.querySelectorAll('button[data-cfam-o]').forEach(function (b) {
            var nay = b === cu;
            b.classList.toggle('is-nay', nay);
            b.setAttribute('aria-pressed', nay ? 'true' : 'false');
          });
          mo(the, false);
        })
        .then(function () { self._dang = false; });
    }
  }
  customElements.define('cfam-the', CfamThe);
})();
